/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    selectedPresetDate: "month",
  },
  view: {
    currentView: "",
    selectedCampaign: null,
  },
};

const campaignSlice = createSlice({
  name: "campaignSlicer",
  initialState,
  reducers: {
    setSelectedPresetDate(state, action) {
      state.filters.selectedPresetDate = action.payload;
    },
    setCampaignView(state, action) {
      state.view.currentView = action.payload.view;
      state.view.selectedCampaign = action.payload.campaign || null;
    },
    clearCampaignView(state) {
      state.view.currentView = "";
      state.view.selectedCampaign = null;
    },
  },
});

export const { setSelectedPresetDate, setCampaignView, clearCampaignView } = campaignSlice.actions;

export const getCampaignView = state => state.campaign.view.currentView;
export const getSelectedCampaign = state => state.campaign.view.selectedCampaign;

export default campaignSlice.reducer;
